module.exports = __webpack_public_path__ + "assets/img/75134f59cfc9774a605e4c8814747463.png";